import React, { FC, useMemo } from "react";
import withTracker from "src/withTracker";
import { Route } from "react-router-dom";
import NavBar from "src/components/navigation/NavBar";
import PermissionStore from "src/context/PermissionStore";
import PickListStore from "src/context/pickListStore";
import { IdleTimeOut } from "src/IdleTimeout";
import Routes from "src/Routes";
import DatasetContext, {
	IState as DatasetContextState,
} from "src/context/DatasetContext";

const RoutesWithTracker = withTracker(Routes);

export const LoggedIn: FC<DatasetContextState> = ({
	currentDataset,
	currentOrganization,
	updateCurrentDataset,
	updateCurrentOrganization,
}) => {
	const contextValue = useMemo(() => {
		return {
			currentDataset,
			currentOrganization,
			updateCurrentDataset,
			updateCurrentOrganization,
		};
	}, [
		currentDataset,
		currentOrganization,
		updateCurrentDataset,
		updateCurrentOrganization,
	]);

	return (
		<DatasetContext.Provider value={contextValue}>
			<PermissionStore>
				<PickListStore>
					<IdleTimeOut>
						<NavBar />
						<Route component={RoutesWithTracker} />
					</IdleTimeOut>
				</PickListStore>
			</PermissionStore>
		</DatasetContext.Provider>
	);
};
